module.exports = __webpack_public_path__ + "media/images/cv/screen_photoweb-6e88a48cb1e589517a3a6681536bd473.png";